import moment from "moment"
import * as R from "ramda"
import React from "react"
import { Link } from "react-router-dom"
import { Button, Modal } from "semantic-ui-react"
import styled from "styled-components"
import OmiseButton from "../../components/OmiseButton/index"
import { calculateTotalValue } from "../../containers/Payment/utils"
import { formatDateTime } from "../../utils/index"

const FullWidthButton = styled(Button)`
  width: 100%;
  max-width: 750px;
  min-height: 40px;
  max-height: 55px;
  height: 55px;
`

const descriptionType = {
  shirt: "เสื้อวิ่งคอกลม",
  v_shirt: "เสื้อวิ่งคอวี",
  undershirt: "เสื้อกล้าม",
  buff: ""
}

export const SummaryOrder = ({
  order,
  handleSubmit,
  bankAccountModalOpen,
  toggleBankAccountModal,
  triggerOmiseForm,
  onPaypalSuccess,
  onOmiseSuccess
}) => (
  <React.Fragment>
    <h1>รายการสั่งซื้อของฉัน</h1>
    <div className="ui grid">
      <div className="eight wide column">
        <h3>{R.path(["event", "title"], order)}</h3>
        <p>ชื่อ: {`${order.firstname} ${order.lastname}`}</p>
        <p>
          ที่อยู่: {order.address_1} {order.sub_district} {order.district}{" "}
          {order.province} {order.postal_code}
        </p>
      </div>
      <div className="sixteen wide column">
        <hr />
      </div>
      <div className="eight wide column">
        {order.addons &&
          order.addons.map(each => (
            <p>
              {descriptionType[R.path(["addon", "type"], each)]}{" "}
              {R.path(["addon", "title"], each)}
            </p>
          ))}
      </div>
      <div className="right aligned eight wide column">
        {order.addons &&
          order.addons.map(each => <p>{R.path(["addon", "price"], each)} ฿</p>)}
      </div>
      <div className="sixteen wide column">
        <hr />
      </div>
      <div className="eight wide column">
        <p>ยอดรวมทั้งสิ้น</p>
      </div>
      <div className="right aligned eight wide column">
        <p>{calculateTotalValue(order)} ฿</p>
      </div>
      <div className="eight wide column">
        <p>ค่าจัดส่ง</p>
      </div>
      <div className="right aligned eight wide column">
        <p>ฟรี</p>
      </div>
      <div className="sixteen wide column" style={{ textAlign: "center" }}>
        <hr />
        วัน/เวลาที่สมัคร : {moment(order.created).format("DD/MM/YYYY HH:mm:ss")}
        <hr />
      </div>
      {!order.is_paid && (
        <div className="sixteen wide column">
          <h3>เลือกช่องทางการชำระเงิน</h3>
          <div style={{ marginBottom: "10px" }}>
            <div style={{ marginBottom: "10px", textAlign: "center" }}>
              <OmiseButton
                {...order}
                targetId={order.id}
                amount={calculateTotalValue(order)}
                onSuccess={onOmiseSuccess}
                type="orders"
              />
            </div>
            <div style={{ marginBottom: "10px", textAlign: "center" }}>
              <FullWidthButton onClick={toggleBankAccountModal} color="teal">
                โอนเงินผ่านธนาคาร
              </FullWidthButton>
            </div>
            <div style={{ marginBottom: "10px", textAlign: "center" }}>
              <h3>
                ชำระภายใน {formatDateTime(moment(order.created).add(2, "days"))}{" "}
                21:49
              </h3>
            </div>
          </div>
        </div>
      )}
    </div>
    <Modal
      open={bankAccountModalOpen}
      closeOnDimmerClick
      onClose={toggleBankAccountModal}
    >
      <Modal.Header>บัญชีธนาคาร</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>ชื่อบัญชี: บริษัท เอ เซอเพนส์ จำกัด</p>
          <p>ธนาคารไทยพาณิชย์ สาขาเซ็นทรัลพลาซ่า เวสต์เกต</p>
          <p>เลขบัญชี: 468-075-836-0</p>
          <p style={{ fontSize: 14 }}>
            *หลังจากโอนเงินแล้วกรุณาแนบหลักฐานการโอนเงินด้วย
          </p>
          <Button onClick={toggleBankAccountModal}>กลับสู่หน้าหลัก</Button>
          <Link to="/confirm-payment">
            <Button color="teal">คลิ๊กที่นี่เพื่อแนบหลักฐานการโอนเงิน</Button>
          </Link>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  </React.Fragment>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/organisms/SummaryOrder/index.js